import { render, staticRenderFns } from "./DashboardIntranet.vue?vue&type=template&id=a3b0c6fe&scoped=true"
import script from "./DashboardIntranet.vue?vue&type=script&lang=js"
export * from "./DashboardIntranet.vue?vue&type=script&lang=js"
import style0 from "./DashboardIntranet.vue?vue&type=style&index=0&id=a3b0c6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b0c6fe",
  null
  
)

export default component.exports